import { render, staticRenderFns } from "./MenuDaily.vue?vue&type=template&id=46dd6dc4"
import script from "./MenuDaily.vue?vue&type=script&lang=js"
export * from "./MenuDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports